export const text = {
  title: "Диалог с пользователем",
  question: "Вопрос",
  answer: "Ответ",
  ready: "Готово",
  rule: "Документ",
  empty: "В данной категории отсутствуют часто задаваемые вопросы"
};
